module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iNiIgd2lkdGg9IjI1IiBoZWlnaHQ9IjE2IiByeD0iMiIgc3Ryb2tlPSIjNjA2MDYwIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTcuMjQgMTNMNSAxMUw3LjI0IDlNMTAuNzYgMTNMMTMgMTFMMTAuNzYgOSIgc3Ryb2tlPSIjNjA2MDYwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/field-icon/code_editor.svg
// module id = nhTM
// module chunks = 46